import React,{useState,useCallback} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'
import Loading from '../../components/shared/loading'

import {
  getCartToken,
} from "./cartToken"

import {
  getDataFromSuccessResponse,
  getErrorFromFailResponse
} from './apiResponse'

import {
  getAttributes
} from "./configuration"

import {
  logoutApp
} from "../../app/action"

import ACCOUNT_API from '../api/account'

export const injectCreditToUserData = (successuserresponse,successcreditresponse) => {
    const userData = getDataFromSuccessResponse(successuserresponse)
    const creditData = getDataFromSuccessResponse(successcreditresponse)
    if(getAttributes(userData) && getAttributes(creditData)){
        const {credit} = getAttributes(creditData)
        const updated = userData
        if(credit){
            updated.attributes.credit = credit
        }
        return updated
    }
    return undefined
}

export let useAccount =  (checkToken) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [getUser, setGetUser] = useState({})
  const [accountList, setAccountList] = useState({})
  const {accountStatus} = useSelector(state=>({
    accountStatus: state.app.accountStatus
  }))
  const logoutButtonCallback = (e) => {
    e.preventDefault()
    logoutApp(dispatch, history)
  }
  const switchAccountCallback = (e)=>{
    e.preventDefault()
    history.push(`${window.location.pathname}?a=checkout&step=account&select=login&list=true`)
  }
  const initAccount = useCallback((cart=true)=>{
    if (checkToken && checkToken.data && checkToken.status === 'success' && getUser.status === undefined) {
      if (checkToken && getAttributes(checkToken.data)) {
        setGetUser({
          ...getUser,
          status: 'loading'
        })
        setAccountList({
          ...accountList,
          status: 'loading'
        })
        ACCOUNT_API.getUser().then(successresponse => {
          //inject credit to user data
          ACCOUNT_API.getAccountCredit().then((successcreditresponse)=>{
            const data = injectCreditToUserData(successresponse,successcreditresponse)
            if(cart){
              const carttoken = getCartToken()
              if (carttoken) {
                setGetUser({
                  ...getUser,
                  status: 'success',
                  data
                })
              } else {
                history.push(history.location.pathname)
              }
            }else{
              setGetUser({
                ...getUser,
                status: 'success',
                data
              })
            }

          })
        }, errorresponse => {
          const error = getErrorFromFailResponse(errorresponse)
          setGetUser({
            ...getUser,
            status: 'error',
            error
          })
        })
        ACCOUNT_API.listAccounts().then(successresponse=>{
          const data = getDataFromSuccessResponse(successresponse)
          setAccountList({
            ...accountList,
            status: 'success',
            data
          })
        },errorresponse => {
          const error = getErrorFromFailResponse(errorresponse)
          setAccountList({
            ...accountList,
            status: 'error',
            error
          })
        })
      }
    }
  },[checkToken, getUser, history,accountList])
  const renderBillingInfo = (cart=true) => {
    const renderInfo = () => {
      const renderSubAccuntInfo = () =>{
        const {status,data} = accountList
        if(status==="success" && data && data.length>1 && checkToken && getAttributes(checkToken.data)){
          const {account_id} = getAttributes(checkToken.data)
          const getSelectedAccount = () => {
            let selected = null
            if(data && data.length){
              selected = data.find(item=>item.id===account_id)
            }
            return selected
          }
          const selectedAcc = getSelectedAccount()
          if(selectedAcc && getAttributes(selectedAcc)){
            const{role,company,firstname,lastname} = getAttributes(selectedAcc)
            const renderCompanyColumn = () => {
              if(company){
                return (
                  <div className={'of-checkout-user-details__column'}>
                    <div className={'of-checkout-user-details__label text-font-2-100'}>Company</div>
                    <div className={'of-checkout-user-details__description text-font-3-100'}>{company}</div>
                  </div>
                )
              }
              return (<></>)
            }
            const renderSwitchAccount = () => {
              if(cart){
                return (<div className={'of-checkout-user-details__row'}>
                  <div className={'of-checkout-user-details__column'}>
                    <button onClick={switchAccountCallback}
                            className='of-checkout-user-details__link primary-font-1-100'>Switch Account
                    </button>
                  </div>
                </div>)
              }
              return (<></>)
            }
            return (
              <div className={'of-checkout-user-details__table of-checkout-user-details__table--no-bottom-line lines-border-1-100'}>
                <div className={'of-checkout-user-details__row'}>
                  <div className={'of-checkout-user-details__column'}>
                    <div className={'of-checkout-user-details__sub-heading text-font-2-100'}>Account</div>
                  </div>
                </div>
                <div className={'of-checkout-user-details__row'}>
                  <div className={'of-checkout-user-details__column'}>
                    <div className={'of-checkout-user-details__label text-font-2-100'}>{role}</div>
                    <div className={'of-checkout-user-details__description text-font-3-100'}>{firstname} {lastname}</div>
                  </div>
                  {renderCompanyColumn()}
                </div>
                {renderSwitchAccount()}
              </div>
            )
          }
        }
        return (<></>)
      }
      const renderAccountInfo = () =>{
        const { data } = getUser
        const { attributes } = data
        const { firstname, lastname, email, phone, address1, city, state, postcode, country } = attributes
        return (<>
          <div className={'of-checkout-user-details__heading text-font-1-100'}>Welcome back, {firstname}!</div>
          {renderSubAccuntInfo()}
          <div className={'of-checkout-user-details__table lines-border-1-100'}>
            <div className={'of-checkout-user-details__row'}>
              <div className={'of-checkout-user-details__column'}>
                <div className={'of-checkout-user-details-main'}>
                  <div className={'of-checkout-user-details-main__name text-font-1-100'}>{firstname} {lastname}</div>
                  <div className={'of-checkout-user-details-main__email text-font-2-100'}>{email}</div>
                </div>
              </div>
              <div className={'of-checkout-user-details__column'}>
                <div className={'of-checkout-user-details__label text-font-2-100'}>Phone Number</div>
                <div className={'of-checkout-user-details__description text-font-3-100'}>{phone}</div>
              </div>
            </div>
            <div className={'of-checkout-user-details__row'}>
              <div className={'of-checkout-user-details__column of-checkout-user-details__column--bottom'}>
                <button onClick={logoutButtonCallback}
                        className='of-checkout-user-details__link primary-font-1-100'>Logout
                </button>
              </div>
              <div className={'of-checkout-user-details__column'}>
                <div className={'of-checkout-user-details__label text-font-2-100'}>Address</div>
                <div className={'of-checkout-user-details__description text-font-3-100'}>
                  {address1}<br/>
                  {city} {state} {postcode}<br/>
                  {country}
                </div>
              </div>
            </div>
          </div>
        </>)
      }
      return (<>
        {renderAccountInfo()}
      </>)
    }
    const renderSection = () => {
      if(getUser.status==="loading" || accountList.status==="loading"){
        return (<Loading className={'of-checkout-user-details__loading-wrapper'}/>)
      }
      if(getUser.status==="success" && accountList.status==="success"){
        return (renderInfo())
      }
      return (<></>)
    }
    if(getUser && getUser.status==="success"){
      return (<div className={'of-checkout-user-details'}>
        {accountStatus === 'error' ? <button onClick={logoutButtonCallback}
                                             className='of-checkout-user-details__link primary-font-1-100'>Logout</button> : <></>}
        {renderSection()}
      </div>)
    }
    return (<></>)
  }
  return({
    getUser,
    accountList,
    accountStatus,
    initAccount,
    renderBillingInfo
  })
}